import axios from 'axios';
import { createErr, createOk, Result } from '../types/result';
import { constructUrl } from './utils';

import {
  ApiKeyTemplate,
  isApiKeyTemplate,
  isApiKeyTemplates,
} from '../types/apiKeyTemplate';

/**
 * コンポーネント機能
 */
const TEMPLATE_URL = '/v1/api-key-templates';

/** 一覧取得 */
export const fetchApiKeyTemplates = async (): Promise<
  Result<ApiKeyTemplate[], Error>
> =>
  axios
    .get(constructUrl(TEMPLATE_URL))
    .then(({ data }: { data: unknown }) => {
      if (!isApiKeyTemplates(data)) {
        throw Error(`Unsupported Value: ${JSON.stringify(data)}`);
      }

      return createOk(data);
    })
    .catch((err: Error) => createErr(err));

/** 詳細取得 */
export const fetchApiKeyTemplatesDetail = async (
  _id: number,
): Promise<Result<ApiKeyTemplate, Error>> =>
  axios
    .get(constructUrl(`${TEMPLATE_URL}/${_id}`))
    .then(({ data }: { data: unknown }) => {
      if (!isApiKeyTemplate(data)) {
        throw Error(`Unsupported Value: ${JSON.stringify(data)}`);
      }

      return createOk(data);
    })
    .catch((err: Error) => createErr(err));

/** 新規登録 */
export const addApiKeyTemplate = async (
  payload: ApiKeyTemplate,
): Promise<Result<ApiKeyTemplate, Error>> =>
  axios
    .post(constructUrl(TEMPLATE_URL), payload)
    .then(({ data }) => createOk(data))
    .catch((err: Error) => createErr(err));

/** 削除 */
export const deleteApiKeyTemplate = async (
  id: number,
): Promise<Result<null, Error>> =>
  axios
    .delete(constructUrl(`${TEMPLATE_URL}/${id}`))
    .then(() => createOk(null))
    .catch((err: Error) => createErr(err));

/** 更新 */
export const editApiKeyTemplate = async (
  id: number,
  payload: ApiKeyTemplate,
): Promise<Result<ApiKeyTemplate, Error>> =>
  axios
    .put(constructUrl(`${TEMPLATE_URL}/${id}`), payload)
    .then(({ data }) => createOk(data))
    .catch((err: Error) => createErr(err));
